import { isIpfsUrl, ipfsFetch } from '@crossbell/ipfs-fetch';
import retry from 'async-retry';

// src/ipfs/index.ts

// src/utils/normalize-character-metadata.ts
function normalizeCharacterMetadata(metadata) {
  if (!metadata)
    return metadata;
  return {
    ...metadata,
    connected_accounts: normalizeConnectedAccounts(metadata.connected_accounts)
  };
}
function normalizeConnectedAccounts(items) {
  if (!Array.isArray(items))
    return [];
  return items.map((item) => {
    switch (typeof item) {
      case "string":
        return item;
      case "object":
        return item && "uri" in item && typeof item.uri === "string" ? item.uri : "";
      default:
        return "";
    }
  }).filter(Boolean);
}

// src/ipfs/index.ts
var IPFS_GATEWAY = "https://w3s.link/ipfs/";
function getIpfsGateway() {
  return IPFS_GATEWAY;
}
function setIpfsGateway(gateway) {
  IPFS_GATEWAY = gateway;
}
function ipfsUploadJson(json) {
  return retry(
    async () => {
      const res = await fetch("https://ipfs-relay.crossbell.io/json", {
        method: "POST",
        body: JSON.stringify(json)
      }).then((res2) => res2.json());
      return res;
    },
    { retries: 3 }
  );
}
function ipfsUploadFile(file) {
  return retry(
    async () => {
      const formData = new FormData();
      formData.append("file", file);
      const res = await fetch("https://ipfs-relay.crossbell.io/upload", {
        method: "post",
        body: formData
      });
      return res.json();
    },
    { retries: 3 }
  );
}
async function ipfsMetadataToUri(metadata) {
  const res = await ipfsUploadJson(metadata);
  if (!res?.url?.startsWith("ipfs://")) {
    throw new Error("upload to IPFS failed");
  }
  return res.url;
}
function ipfsUriToMetadata(uri) {
  return retry(
    async () => {
      if (isIpfsUrl(uri)) {
        const res2 = await ipfsFetch(uri).then((res3) => res3.text());
        try {
          const json = JSON.parse(res2);
          return json;
        } catch {
          throw new Error(`Failed to parse metadata from uri: ${uri}`);
        }
      }
      let res = "";
      try {
        res = await fetch(uri).then((res2) => res2.text());
        res = JSON.parse(res);
        return res;
      } catch {
        throw new Error(
          `Failed to fetch metadata from uri: ${uri} . Response: ${res}`
        );
      }
    },
    { retries: 3 }
  );
}
async function ipfsParseMetadataOrUri(type, metadataOrUri, retrieveMetadataIfNeeded = false) {
  if (metadataOrUri === "") {
    return { uri: "", metadata: void 0 };
  }
  let uri;
  let metadata;
  if (typeof metadataOrUri === "string") {
    uri = metadataOrUri;
    metadata = retrieveMetadataIfNeeded ? await ipfsUriToMetadata(uri) : void 0;
  } else {
    metadata = metadataOrUri;
    if (!metadata.type) {
      metadata.type = type;
    }
    uri = await ipfsMetadataToUri(metadata);
  }
  if (metadata && type === "character") {
    metadata = normalizeCharacterMetadata(metadata);
  }
  return {
    metadata,
    uri
  };
}

export { getIpfsGateway, ipfsMetadataToUri, ipfsParseMetadataOrUri, ipfsUploadFile, ipfsUploadJson, ipfsUriToMetadata, normalizeCharacterMetadata, setIpfsGateway };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-XMIRV277.mjs.map